import React from "react";
import { lock, unlock } from "../../../images/images";
import styles from "./TokenHistory.module.css";
import { ethers } from "ethers";

const TokenHistory = ({ history }) => {
  const formatedDate = (time) => {
    const dateObj = new Date(time);

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  };
  return (
    <div className={styles.historyContainer}>
      <div className={styles.historyWrapper}>
        <p></p>
        <div className={styles.header}>
          <p className={styles.title}>type</p>{" "}
          <p className={[styles.title, styles.time].join(" ")}>Block Number</p>{" "}
          <p className={styles.title}>Amount</p>
        </div>
      </div>
      <div className={[styles.allHistories, styles.grScrollbar].join(" ")}>
        {history.map((el, i) => (
          <div
            className={[
              styles.historyWrapper,
              styles.histories,
              el.type.toLowerCase() === "unstake" &&
              styles.unstakeHistories,
            ].join(" ")}
            key={i}
          >
            <div
              className={[
                styles.lockBox,
                el.type.toLowerCase() === "unstake" &&
                styles.unstakeLockBox,
              ].join(" ")}
            >
              <img
                src={el.type.toLowerCase() === "unstake" ? unlock : lock}
                alt="#"
                className={styles.lockIcon}
              />
            </div>
            <div className={styles.history}>
              <p className={styles.text}>{el.type}</p>{" "}
              <p className={[styles.text, styles.time].join(" ")}>
                {(el.blockNumber)}
              </p>{" "}
              <p className={styles.text}>{Number(ethers.utils.formatEther(el.amount)).toFixed(2)}</p>{" "}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TokenHistory;
